import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { TextField } from '@mui/material';
import { validInteger } from 'app/helpers/numberHelper';
import { isEmpty } from 'lodash';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectIsEmiLmoDisabled } from 'store/redux-store/placement-mods/selectors';

export const EmiDaysWaived = () => {
  const { control, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const emiDaysWaived: number | string | null | undefined = useWatch({ name: 'emiDaysWaived' });
  const emiNumberOfDays: number | string | null | undefined = useWatch({ name: 'emiNumberOfDays' });
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const emiCostPerDay: number | string | null | undefined = useWatch({ name: 'emiCostPerDay' });
  const earlyMoveInDate: Date | string | null | undefined = useWatch({ name: 'earlyMoveInDate' });
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const checkRequired = () => {
    if (
      (!isNullOrUndefined(earlyMoveInDate) && !isEmpty(earlyMoveInDate)) ||
      (!isNullOrUndefined(emiNumberOfDays) && emiNumberOfDays !== '') ||
      (!isNullOrUndefined(emiCostPerDay) && emiCostPerDay !== '') ||
      (!isNullOrUndefined(emiDaysWaived) && emiDaysWaived !== '')
    ) {
      return true;
    }
    return false;
  };
  const checkDaysValidation = currentEmiDaysWaived => {
    if (!isNullOrUndefined(emiNumberOfDays) && !isNullOrUndefined(currentEmiDaysWaived)) {
      if (Number(currentEmiDaysWaived) > Number(emiNumberOfDays)) {
        setError('emiNumberOfDays', { message: t('placement.placementMods.daysWaivedError') });
        return;
      }
    } else {
      clearErrors('emiNumberOfDays');
    }
    if (!checkRequired()) {
      clearErrors('emiNumberOfDays');
    }
    return null;
  };

  return (
    <Controller
      control={control}
      name={'emiDaysWaived'}
      rules={{
        validate: checkDaysValidation,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          id="emiDaysWaived"
          color="primary"
          label={t('placement.placementMods.daysWaived')}
          InputProps={{
            readOnly: !isModEdit || isEmiLmoDisabled,
            style: {
              pointerEvents: (isModEdit || isSaveModApiCalling) && !isEmiLmoDisabled ? 'auto' : 'none',
            },
          }}
          InputLabelProps={{
            shrink: emiDaysWaived ? true : null,
            sx: { marginTop: emiDaysWaived ? '0px' : '-10px' },
          }}
          onChange={e => {
            if (validInteger(e.target.value, { numberLength: 4 })) {
              setValue('emiDaysWaived', e.target.value, { shouldDirty: true });
              onChange(e.target.value);
            }
          }}
          value={emiDaysWaived}
          disabled={isSaveModApiCalling}
          required={false}
          {...rest}
        />
      )}
    />
  );
};
